import React from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";


const Star= styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    svg{
      stroke: var(--star);
      stroke-width:2rem;
    }
`;

class Stars extends React.Component {
  checkStar=()=>{
    if((this.props.star) % 1 === 0){
     return true
    }else{
      return false
    }
  }
  gradiant=()=>{
    if(this.checkStar()){
      return (this.props.star)
    }else{
      if((this.props.star - parseInt(this.props.star)) > 0.5){
        return((parseInt(this.props.star) + 1))
      }else{
        return (parseInt(this.props.star))
      }
    }
  }
  // gradiantHover=()=>{
  //   if(this.checkStar()){
  //     return (this.props.star)
  //   }else{
  //     if((this.props.star - parseInt(this.props.star)) > 0.5){
  //       return((parseInt(this.props.star) + 1))
  //     }else{
  //     return (parseInt(this.props.star))
  //     }
  //   }
  // }

  render() {
    let stars = [];
    for (let i = 0; i < 5 ; i++) {
      stars.push(
        <FontAwesomeIcon
          icon={faStar}
          style={{ color: i < this.gradiant() ? 'var(--star)' : "var(--light-bg)" }}
          key={i}
        />
      );
    }
    return <Star className="star">{stars}</Star>;
  }
}
export default Stars;
